import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiLink,
  EuiSpacer,
  EuiText,
} from "@inscopix/ideas-eui";
import { UserAvatar } from "components/UserAvatar/UserAvatar";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { PanelTenantUsageContent } from "components/PanelTenantUsage/PanelTenantUsageContent";
import { OrganizationActions } from "./OrganizationActions";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { useTourStep } from "providers/TourProvider/TourProvider.hooks";

interface PageOrganizationSidebarOrgProps {
  isPersonalSpace: boolean;
}

const PageOrganizationSidebarOrg = ({
  isPersonalSpace,
}: PageOrganizationSidebarOrgProps) => {
  const currentTenant = useTenantContext((s) => s.currentTenant);
  const isOrgAdmin = useUserContext(
    (s) =>
      s.tenants.find((tenant) => tenant.id === currentTenant.id)?.role.key ===
      "admin",
  );
  const name = isPersonalSpace ? "Personal Space" : currentTenant.name;

  return (
    <EuiFlexGroup alignItems="center" gutterSize="xs">
      <EuiFlexItem>
        <EuiFlexGroup gutterSize={"none"}>
          <EuiFlexItem>
            <EuiText title={name}>
              <h3>{name}</h3>
            </EuiText>
          </EuiFlexItem>
          <EuiSpacer size="xs" />
          <EuiFlexItem grow={false}>
            {isOrgAdmin && !isPersonalSpace && (
              <OrganizationActions orgKey={currentTenant.key} />
            )}
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};

const PageOrganizationSidebarPeople = () => {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  const currentTenant = useTenantContext((s) => s.currentTenant);

  const tenantUsers = useTenantContext((s) => s.tenantUsers);

  const { component: TourOrganizationManage1, anchorId } = useTourStep(
    "TourOrganizationManage",
    1,
  );

  return (
    <EuiFlexGroup direction="column" gutterSize={"s"}>
      <EuiFlexItem>
        <EuiText>
          <h4>
            <EuiLink
              to={
                routeMap.ORGANIZATION_PEOPLE.dynamicPath({
                  tenantKey: currentTenant.key,
                }).path
              }
              id={anchorId}
            >
              People
            </EuiLink>
            {TourOrganizationManage1}
          </h4>
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize={"s"} wrap={true} responsive={false}>
          {tenantUsers
            .filter(({ internal, isActive }) => !internal && isActive)
            .map((user) => (
              <EuiFlexItem key={user.id} grow={false}>
                <UserAvatar userId={user.id} size="l" />
              </EuiFlexItem>
            ))}
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};

const PageOrganizationSideBarUsage = () => {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  const currentTenant = useTenantContext((s) => s.currentTenant);

  const { component: TourOrganizationManage2, anchorId } = useTourStep(
    "TourOrganizationManage",
    2,
  );

  return (
    <EuiFlexGroup direction="column" gutterSize={"s"}>
      <EuiFlexItem>
        <EuiText>
          <h4>
            <EuiLink
              to={
                routeMap.ORGANIZATION_USAGE.dynamicPath({
                  tenantKey: currentTenant.key,
                }).path
              }
              id={anchorId}
            >
              Usage
            </EuiLink>
            {TourOrganizationManage2}
          </h4>
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem>
        <PanelTenantUsageContent compact />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};

interface PageOrganizationSideBarProps {
  isPersonalSpace: boolean;
}

export const PageOrganizationSideBar = ({
  isPersonalSpace,
}: PageOrganizationSideBarProps) => {
  return (
    <EuiFlexGroup direction="column" gutterSize="xl">
      <EuiFlexItem>
        <PageOrganizationSidebarOrg isPersonalSpace={isPersonalSpace} />
      </EuiFlexItem>
      {!isPersonalSpace && (
        <EuiFlexItem>
          <PageOrganizationSidebarPeople />
        </EuiFlexItem>
      )}
      <EuiFlexItem>
        <PageOrganizationSideBarUsage />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
